<template>
  <el-container style="position:absolute;left: 0;right: 0;bottom: 0;top: 0">
    <!-- 管理主界面 -->
    <el-row v-if="loaded" style="min-width: 1440px;width: 100%;height: 100%">
      <!-- 顶栏 -->
      <HeaderMain></HeaderMain>
      <el-col :span="4" :offset="2" style="height: 100%">
        <el-menu id="app-control-menu-el" :default-active="activeIndex" background-color="#eff1f4"
                 active-text-colo="#000000">
          <el-menu-item index="1" v-if="this.$store.state.permissionList.userAdmin" v-on:click="changeIndex('1')"
                        disabled>
            <em class="el-icon-setting"></em>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="2" v-if="this.$store.state.permissionList.fullAdmin" v-on:click="changeIndex('2')"
                        disabled>
            <em class="el-icon-setting"></em>
            <span slot="title">角色管理</span>
          </el-menu-item>
          <el-menu-item index="3" v-if="this.$store.state.permissionList.fullAdmin" v-on:click="changeIndex('3')"
                        disabled>
            <em class="el-icon-setting"></em>
            <span slot="title">权限管理</span>
          </el-menu-item>
          <el-menu-item index="4" v-if="this.$store.state.permissionList.curriculumAdmin"
                        v-on:click="changeIndex('4')">
            <em class="el-icon-setting"></em>
            <span slot="title">分类管理</span>
          </el-menu-item>
          <el-menu-item index="5" v-if="this.$store.state.permissionList.curriculumAdmin"
                        v-on:click="changeIndex('5')">
            <em class="el-icon-setting"></em>
            <span slot="title">难度管理</span>
          </el-menu-item>
          <el-menu-item index="6" v-if="this.$store.state.permissionList.curriculumAdmin"
                        v-on:click="changeIndex('6')">
            <em class="el-icon-setting"></em>
            <span slot="title">课程管理</span>
          </el-menu-item>
          <el-menu-item index="7" v-if="this.$store.state.permissionList.curriculumAdmin"
                        v-on:click="changeIndex('7')">
            <em class="el-icon-setting"></em>
            <span slot="title">章节管理</span>
          </el-menu-item>
          <el-menu-item index="8" v-if="this.$store.state.permissionList.curriculumAdmin"
                        v-on:click="changeIndex('8')">
            <em class="el-icon-setting"></em>
            <span slot="title">文章管理</span>
          </el-menu-item>
          <el-menu-item index="9" v-if="this.$store.state.permissionList.propertyAdmin"
                        v-on:click="changeIndex('9')">
            <em class="el-icon-setting"></em>
            <span slot="title">资产类型管理</span>
          </el-menu-item>
          <el-menu-item index="10" v-if="this.$store.state.permissionList.propertyAdmin"
                        v-on:click="changeIndex('10')">
            <em class="el-icon-setting"></em>
            <span slot="title">兑换码管理</span>
          </el-menu-item>
          <el-menu-item index="11" v-if="this.$store.state.permissionList.propertyAdmin"
                        v-on:click="changeIndex('11')">
            <em class="el-icon-setting"></em>
            <span slot="title">激活码库存管理</span>
          </el-menu-item>
          <el-menu-item index="12" v-if="this.$store.state.permissionList.curriculumAdmin"
                        v-on:click="changeIndex('12')" disabled>
            <em class="el-icon-setting"></em>
            <span slot="title">存储池管理</span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <!-- 内容 -->
      <el-col :span="16" style="background: #FFFFFF;height: 100%">
        <ControlHome v-if="activeIndex === '0'"></ControlHome>
        <CurriculumClassificationControl v-if="activeIndex === '4'"></CurriculumClassificationControl>
        <CurriculumLvlControl v-if="activeIndex === '5'"></CurriculumLvlControl>
        <CurriculumListControl v-if="activeIndex === '6'"></CurriculumListControl>
        <CurriculumChapterControl v-if="activeIndex === '7'"></CurriculumChapterControl>
        <CurriculumClassControl v-if="activeIndex === '8'"></CurriculumClassControl>
        <PropertyTypeControl v-if="activeIndex === '9'"></PropertyTypeControl>
        <ActivationCodeControl v-if="activeIndex === '10'"></ActivationCodeControl>
        <PropertyControl v-if="activeIndex === '11'"></PropertyControl>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>

import '@/views/control/control.css'
import '@/views/control/control-media.css'

import AxiosBase from "@/components/axiosBase";
import store from "@/components/dataStore";
import {Message} from "element-ui";
import CurriculumClassificationControl from "@/views/control/components/curriculum/CurriculumClassificationControl";
import CurriculumLvlControl from "@/views/control/components/curriculum/CurriculumLvlControl";
import CurriculumListControl from "@/views/control/components/curriculum/CurriculumListControl";
import CurriculumChapterControl from "@/views/control/components/curriculum/CurriculumChapterControl";
import CurriculumClassControl from "@/views/control/components/curriculum/CurriculumClassControl";
import ActivationCodeControl from "@/views/control/components/property/ActivationCodeControl";
import PropertyControl from "@/views/control/components/property/PropertyCodeControl";
import HeaderMain from "@/views/share/HeaderMain";
import ControlHome from "@/views/control/components/ControlHome";
import PropertyTypeControl from "@/views/control/components/property/PropertyTypeControl";

export default {
  name: "ControlCenter",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    PropertyTypeControl,
    // eslint-disable-next-line vue/no-unused-components
    ControlHome,
    // eslint-disable-next-line vue/no-unused-components
    HeaderMain,
    // eslint-disable-next-line vue/no-unused-components
    PropertyControl,
    // eslint-disable-next-line vue/no-unused-components
    ActivationCodeControl,
    // eslint-disable-next-line vue/no-unused-components
    CurriculumClassControl,
    // eslint-disable-next-line vue/no-unused-components
    CurriculumChapterControl,
    // eslint-disable-next-line vue/no-unused-components
    CurriculumListControl,
    // eslint-disable-next-line vue/no-unused-components
    CurriculumLvlControl,
    // eslint-disable-next-line vue/no-unused-components
    CurriculumClassificationControl
  },
  store,
  data() {
    return {
      loaded: false,
      activeIndex: '0',
    }
  },
  beforeCreate() {
    if (this.$store.state.userInfo !== {}) {
      AxiosBase.axiosGet("/user-ad/get-permissions").then(response => {
        if (response !== 0) {
          this.$store.state.permissionList = response.data;
          this.loaded = true;
        } else {
          this.$router.push("/")
        }
      })
    } else {
      Message({
        showClose: true,
        message: '(⊙ˍ⊙)????????',
        type: 'warning'
      });
      this.$router.push("/")
    }
  },
  mounted() {
    document.title = "斑斓魔法CG-控制中心";
  },
  methods: {
    changeIndex(var1) {
      this.activeIndex = var1;
    },
  },
}
</script>

<style scoped>

#app-control-menu-el {
  height: 100%;
}

</style>